import * as XLSX from 'xlsx';

export default {

  /**
   * 将原始数据通过头部配置转换为导出需要的数据
   * @param {Object} originData 原始数据
   */
  transformDataIntoRows(
    originData,
    headerMap,
  ) {
    // 结果是一个对象，有很多字符串属性，属性值是一个对象数组
    const result = [];

    originData.forEach((item) => {
      const applicant = {};

      // 显示表头
      Object.keys(headerMap).forEach((key) => {
        applicant[headerMap[key]] = item[key];
      });
      result.push(applicant);
    });

    return result;
  },

  /**
   * 导出到Excel，json数据格式导出
   * @param {Array} translatedData 翻译过后的数组
   */
  exportIntoXLSXByJson(
    originData,
    headerMap,
    fileName,
    sheetName = 'sheet',
  ) {
    const transferedData = this.transformDataIntoRows(originData, headerMap);

    // 创建一个新的workBook
    const workBook = XLSX.utils.book_new();

    // 生成一个Sheet
    const workSheet = XLSX.utils.json_to_sheet(transferedData);

    // 将Sheet加入到workBook, 并设置Sheet名
    XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);

    // 命名并写出文件
    XLSX.writeFile(workBook, fileName);
  },
  exportIntoXLSXByJsonList(
    originDataList,
    headerList,
    fileName,
    sheetNameList = [],
    exportTypeList = [],
  ) {


    // 创建一个新的workBook
    const workBook = XLSX.utils.book_new();
    // 创建多个表
    originDataList.forEach((data, index) => {
      let workSheet = null;
      // 根据导出的类型进行导出
      const exportType = exportTypeList[index];
      if (exportType === 'aoa') {
        workSheet = XLSX.utils.aoa_to_sheet(originDataList[index]);
      } else {
        const transferedData = this.transformDataIntoRows(data, headerList[index]);
        // 生成一个Sheet
        workSheet = XLSX.utils.json_to_sheet(transferedData);
      }
      // 将Sheet加入到workBook, 并设置Sheet名
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetNameList[index] || `sheet${index}${1}`);
    });
    

    // 命名并写出文件
    XLSX.writeFile(workBook, fileName);
  },
};



// WEBPACK FOOTER //
// ./src/services/export-service.js